<template>
  <div class="section section-center">
    <div class="login-wrap">
      <Welcome text="Приглашение в систему">
        <div class="text-secondary ts-center">
          Введите ваш пароль ниже.
        </div>
      </Welcome>

      <RestoreForm />
    </div>
  </div>
</template>

<script>
  import Welcome from '@/containers/auth/Welcome';
  import RestoreForm from '@/containers/auth/RestoreForm';

  export default {
    name: 'Reset',
    components: {RestoreForm, Welcome},
  };
</script>
